import * as React from "react";
const IconSuspectCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M32 2C15.5 2 2 15.5 2 32s13.5 30 30 30 30-13.5 30-30S48.5 2 32 2m0 58C16.6 60 4 47.4 4 32S16.6 4 32 4s28 12.6 28 28-12.6 28-28 28" />
    <path d="M45.2 44.2H18.8c-.6 0-1 .4-1 1s.4 1 1 1h26.4c.6 0 1-.4 1-1s-.5-1-1-1M27.7 21.5c0-.6-.4-1-1-1H16.2c-.6 0-1 .4-1 1s.4 1 1 1h10.5c.6 0 1-.5 1-1M47.8 20.5H37.3c-.6 0-1 .4-1 1s.4 1 1 1h10.5c.6 0 1-.4 1-1s-.4-1-1-1" />
  </svg>
);
export default IconSuspectCopy;
